import React, { useState, useEffect } from "react";
import banner from "../../images/careers/banner.jpg";
import WOW from "wowjs";
import mbBanner from "../../images/careers/mbBanner.jpg";
import BannerItem from "../../component/BannerItem/BannerItem";
import Button from "../../component/Button/Button";
import useWindowDimensions from "../../useWindowDimensions";
import "./style.less";
import { Col, Row, Modal } from "react-bootstrap";
import JobPostItem from "../../component/JobPostItem/JobPostItem";
import JobApplyModel from "../../component/JobApplyModel/JobApplyModel";
import PaginationComponent from "../../component/PaginationComponent/PaginationComponent";
import resumeRightSideBanner from "../../images/careers/resumeRightSideBanner.png";
import portfolio from "../../images/careers/portfolio.svg";
import resume from "../../images/careers/resume.svg";
import loadergif from "../../images/loader.gif";
import close from "../../images/close.svg";
import check from "../../images/check.svg";

import search from "../../images/careers/search.svg";
import InputText from "../../component/InputText/InputText";
import axios from "axios";
import urldata from "../../urldata";
import moment from "moment";
import Toast from "../../component/Toast/Toast";

import Imageurldata from "../../Imageurldata";

const testList = [
  {
    id: 1,
    title: "Success",
    description: "This is a success toast component",
    backgroundColor: "#5cb85c",
    icon: check,
  },
  {
    id: 2,
    title: "Danger",
    description: "This is an error toast component",
    backgroundColor: "#d9534f",
    icon: close,
  },
];

const Careers = (props) => {
  const { height, width } = useWindowDimensions();
  const [modalShow, setModalShow] = useState(false);
  const [uploadResume, setUploadResume] = useState("");
  const [uploadResumeErr, setUploadResumeErr] = useState("");
  const [jobPostList, setJobPostList] = useState([]);

  const [keywordSearch, setKeywordSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [metaData, setMetaData] = useState({});
  const [jobId, setJobId] = useState("");
  const [applyDesignatiom, setApplyDesignatiom] = useState("");

  const [totalPage, setTotalPage] = useState(0);
  const [selectedPage, setSelectedPage] = useState(0);
  const [totalPageArray, setTotalPageArray] = useState([]);
  const [inSearch, setInSearch] = useState(false);

  const [selectedArray, setSelectedArray] = useState([]);
  const [totalSlicePageArray, setTotalSlicePageArray] = useState([]);

  const [pgLoading, setPgLoading] = useState(true);
  const [loading, setLoading] = useState(true);

  const [deskloading, setdeskLoading] = useState(true);

  const [noResultFound, setnoResultFound] = useState(false);

  const [list, setList] = useState([]);

  const [careerPageData, setCareerPageData] = useState([]);

  let toastProperties = null;

  useEffect(() => {
    window.scroll(0, 0);
    new WOW.WOW({
      live: false,
    }).init();

    let url = new URL(urldata + "user/getCareerPageData");

    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        // console.log(response.data.data);
        const homedata = response.data.data;
        // console.log(homedata)
        setCareerPageData(homedata);

        document.title = "Careers - Join Us";
        document.getElementsByTagName("META")[3].content =
          "Join our team in its mission to bring innovation to the food industry.";
        document.getElementsByTagName("META")[4].content =
          "House of Spice Jobs, Vacancies, Food Industry Jobs, Careers";

        setdeskLoading(false);
      })
      .catch((error) => {
        //alert("Something Went Wrong");
      });
  }, []);

  const applyjob = (id, designation) => {
    setJobId(id);
    setApplyDesignatiom(designation);
    setModalShow(true);
  };

  const hasExtension = (inputID, exts) => {
    var fileName = document.getElementById(inputID).value;
    return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
      fileName
    );
  };

  const uploadCvBtnClick = () => {
    var formIsValid = true;
    if (!uploadResume) {
      formIsValid = false;
      setUploadResumeErr("*Please upload your resume.");
    } else {
      setUploadResumeErr("");
    }
    if (uploadResume) {
      var FileSize = resume.size / 1024 / 1024;
      if (FileSize > 2) {
        setUploadResumeErr("File size exceeds 2 MiB");
      }
    }

    if (!hasExtension("uploadResume", [".jpg", ".pdf", ".doc", ".docx"])) {
      setUploadResumeErr("Please Select Valid Format");
      formIsValid = false;
    }

    if (formIsValid) {
      var formData = new FormData();
      formData.append("resume", uploadResume);
      let url = new URL(urldata + "user/applyForJobThroughResume");

      let data = {};
      data.date = moment().format("DD-MM-YYYY");
      data.time = moment().format("hh:mm a");

      Object.keys(data).forEach((key) =>
        url.searchParams.append(key, data[key])
      );
      var decoded = decodeURIComponent(url);

      axios({
        method: "post",
        url: decoded,
        data: formData,
        withCredentials: true,
      })
        .then((response) => {
          //console.log("added");
          document.getElementById("uploadResume").value = "";
          setUploadResumeErr("");
          setUploadResume("");
          showToast("success2");
        })
        .catch((error) => {
          // alert("Something Went Wrong")
          showToast("danger");
        });
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
    document.title = "Hos - Career";
    getJobPost();
  }, []);

  const getJobPost = () => {
    let url = new URL(urldata + "user/jobPost");

    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        //console.log("added", response.data.data);
        const list = response.data.data;
        list.reverse();
        setJobPostList(list);

        setSelectedPage(0);

        setTotalPage(Math.ceil(list.length / 3));
        let temp = [];
        ////console.log(
        //   Math.ceil(AutomotiveArr.length / 4),
        //   AutomotiveArr.length
        // )
        for (let i = 1; i <= Math.ceil(list.length / 3); i++) {
          temp.push(i);
        }
        setTotalPageArray(...[temp]);
        ////console.log(temp)
        setTotalSlicePageArray(...[temp.slice(0, 3)]);
        let pagestart = 0;
        let temp2 = [...list];
        setSelectedArray(temp2.slice(pagestart, pagestart + 3));
        setLoading(false);
        try {
          document.getElementById("paginationLeftarrow").style.opacity = ".5";
          document.getElementById("paginationLeftarrow").style.cursor =
            "initial";
        } catch (error) {}
      })
      .catch((error) => {
        //console.log(error);
        showToast("danger");
        setLoading(false);
        //alert("Something Went Wrong2")
      });
  };

  useEffect(() => {
    let pagestart = selectedPage * 3;
    let temp = [...jobPostList];
    setSelectedArray(temp.slice(pagestart, pagestart + 3));
    setTotalPage(Math.ceil(jobPostList.length / 3));
    leftArrowClickOpacityHandle();
    rightArrowClickOpacityHandle();
  }, [selectedPage]);

  const leftArrowClickOpacityHandle = () => {
    if (selectedPage === 0) {
      try {
        document.getElementById("paginationLeftarrow").style.opacity = ".5";
        document.getElementById("paginationLeftarrow").style.cursor = "initial";
      } catch (error) {}
    } else {
      try {
        document.getElementById("paginationLeftarrow").style.opacity = "1";
        document.getElementById("paginationLeftarrow").style.cursor = "pointer";
      } catch (error) {}
    }
  };

  const rightArrowClickOpacityHandle = () => {
    if (totalPage === selectedPage + 1) {
      try {
        document.getElementById("paginationrightarrow").style.opacity = ".5";
        document.getElementById("paginationrightarrow").style.cursor =
          "initial";
      } catch (error) {}
    } else {
      try {
        document.getElementById("paginationrightarrow").style.opacity = "1";
        document.getElementById("paginationrightarrow").style.cursor =
          "pointer";
      } catch (error) {}
    }
  };

  const searchBtnClick = () => {
    setLoading(true);
    var data = {};
    data.searchData = keywordSearch;
    data.location = locationSearch;
    setInSearch(true);
    if (keywordSearch === "" && locationSearch === "") {
      setInSearch(false);
      return getJobPost();
    }

    let url = new URL(urldata + "user/searchJob");
    axios({
      method: "post",
      url: url,
      data: data,
    })
      .then((response) => {
        //console.log("added", response.data.data);
        const list = response.data.data;
        list.reverse();
        setJobPostList(list);

        setSelectedPage(0);

        setTotalPage(Math.ceil(list.length / 3));
        let temp = [];
        ////console.log(
        //   Math.ceil(AutomotiveArr.length / 4),
        //   AutomotiveArr.length
        // )
        for (let i = 1; i <= Math.ceil(list.length / 3); i++) {
          temp.push(i);
        }
        setTotalPageArray(...[temp]);
        ////console.log(temp)
        setTotalSlicePageArray(...[temp.slice(0, 3)]);
        let pagestart = 0;
        let temp2 = [...list];
        setSelectedArray(temp2.slice(pagestart, pagestart + 3));
        setLoading(false);
        try {
          document.getElementById("paginationLeftarrow").style.opacity = ".5";
          document.getElementById("paginationLeftarrow").style.cursor =
            "initial";
        } catch (error) {}
      })
      .catch((error) => {
        // alert("Something Went Wrong")
        //console.log(error);
        setLoading(false);
        showToast("danger");
        // showToast("success")
      });
  };

  const jobList = selectedArray.map((item, i) => {
    return (
      <JobPostItem
        key={i}
        designation={item.designation}
        location={item.location}
        experienceInYear={item.experienceInYear}
        experience={
          item.fromExp + " - " + item.toExp + " " + item.experienceInYear
        }
        desc={item.desc}
        skills={item.skills}
        onClick={() => applyjob(item._id, item.designation)}
      />
    );
  });

  const leftArrowClick = () => {
    if (!(selectedPage - 1 < 0)) {
      if (totalPageArray.length - 2 >= selectedPage) {
        setTotalSlicePageArray(
          totalPageArray.slice(selectedPage - 1, selectedPage + 2)
        );
      }
      setSelectedPage(selectedPage - 1);
      scrollToDiv();
    }
  };
  const nextArrowClick = () => {
    if (selectedPage + 1 !== totalPageArray.length) {
      if ((selectedPage + 1) % 2 === 0 || selectedPage >= 2) {
        setTotalSlicePageArray(
          totalPageArray.slice(selectedPage, selectedPage + 3)
        );
      }

      setSelectedPage(selectedPage + 1);

      scrollToDiv();
    }
    // totalPageArray.length === (selectedPage+1) ?null :
  };
  const scrollToDiv = () => {
    const id = "list";
    const yOffset = -170;
    const element = document.getElementById(id);
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const paginationNoClick = (i) => {
    setSelectedPage(i - 1);
    scrollToDiv();
  };

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: "Your Form Sumbitted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "success2":
        toastProperties = {
          id,
          title: "Success",
          description: "Your Resume Uploaded Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setList([]);
    }

    setList([...list, toastProperties]);
  };

  if (deskloading) {
    return (
      <div className="loadergifdiv">
        <img src={loadergif} className="img-fluid" />
      </div>
    );
  }

  return (
    <>
      <BannerItem
        img={
          width > 640
            ? Imageurldata + careerPageData.bannerData[0].imgUrl
            : Imageurldata + careerPageData.bannerData[0].mbimgUrl
        }
        title={careerPageData.bannerData[0].title}
        color="white"
      />
      <section className="careersSec2 wow fadeIn">
        <div className="title">
          <div
            dangerouslySetInnerHTML={{
              __html: careerPageData.careersec2[0].title.replace(
                /(<? *script)/gi,
                "illegalscript"
              ),
            }}
          ></div>
        </div>
        <div className="desc">
          <div
            dangerouslySetInnerHTML={{
              __html: careerPageData.careersec2[0].desc.replace(
                /(<? *script)/gi,
                "illegalscript"
              ),
            }}
          ></div>
        </div>
      </section>
      <section className="careersSec3 wow fadeIn">
        <div className="title">
          Please enter Keywords or Location to search.
        </div>
        <div className="searchContainer d-f">
          <div className="inputContainer">
            {width > 1023 ? (
              <>
                <div className="h-f d-f firstInputContainer">
                  <div>
                    <img src={search} />
                  </div>
                  <input
                    type="text"
                    onChange={(e) => setKeywordSearch(e.target.value)}
                    value={keywordSearch}
                    placeholder="Skills/Designation/Experience"
                  />
                </div>
                <div className="h-f d-f secondInputContainer">
                  <input
                    type="text"
                    onChange={(e) => setLocationSearch(e.target.value)}
                    value={locationSearch}
                    placeholder="Location"
                  />
                </div>
              </>
            ) : (
              <>
                <div className="mbfirstInputContainer">
                  <input
                    type="text"
                    onChange={(e) => setKeywordSearch(e.target.value)}
                    value={keywordSearch}
                    placeholder="Skills/Designation/Experience"
                  />
                </div>
                <div className="mbSecondInputContainer">
                  <input
                    onChange={(e) => setLocationSearch(e.target.value)}
                    type="text"
                    value={locationSearch}
                    placeholder="Location"
                  />
                </div>
              </>
            )}
          </div>
          <div className="btnContainer">
            <Button onClick={searchBtnClick} title="SEARCH" />
          </div>
        </div>
      </section>

      <section className="careersSec4 " id="list">
        {loading ? (
          // <h1>Loading....</h1>
          <div id="wrapper">
            <div className="profile-main-loader">
              <div className="loader">
                <svg className="circular-loader" viewBox="25 25 50 50">
                  <circle
                    class="loader-path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke="#ed1c24"
                    strokeWidth="2"
                  />
                </svg>
              </div>
            </div>
          </div>
        ) : (
          <>
            {jobPostList.length !== 0 ? (
              <>
                <div className="listContainer">{jobList}</div>

                {totalPageArray.length === 1 ? null : (
                  <div className="d-f j-c a-c productListPaginationContainer">
                    <div onClick={leftArrowClick} id="paginationLeftarrow">
                      Prev
                    </div>
                    <PaginationComponent
                      // paginationNoClick={(item) => paginationNoClick(item)}
                      totalPageArray={totalSlicePageArray}
                      selectedPage={selectedPage}
                      paginationNoClick={(item) => paginationNoClick(item)}
                    />

                    <div onClick={nextArrowClick} id="paginationrightarrow">
                      Next
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="noresult">No Results Found</div>
            )}
          </>
        )}
      </section>

      <section className="careersSec5 wow fadeIn">
        <Row className="row">
          <Col className="firstCol p-0" lg={5}>
            <div className="dropyourcvContainer">
              <div className="d-f a-c">
                <div>
                  <img src={resume} className="resume" />
                </div>
                <div className="titleTxt">Drop Your CV Here</div>
              </div>
              <div className="desc">
                We will consider your profile for future jobs
              </div>
              <div className="inputContainer">
                <InputText
                  onChange={(e) => setUploadResume(e.target.files[0])}
                  chooseFile
                  id="uploadResume"
                />
                <div style={{ paddingTop: "1em" }}>{uploadResume.name}</div>
                <div className="err">{uploadResumeErr}</div>
              </div>
              <div className="btnContainer">
                <Button onClick={uploadCvBtnClick} title="SUBMIT" />
              </div>
            </div>
          </Col>
          <Col className="secondCol p-0" lg={7}>
            <img src={resumeRightSideBanner} className="img-fluid" />
          </Col>
        </Row>
      </section>

      <JobApplyModel
        show={modalShow}
        props={props}
        id={jobId}
        showToast={showToast}
        designation={applyDesignatiom}
        onHide={() => setModalShow(false)}
      />

      <Toast toastList={list} position="top-right" />
    </>
  );
};

export default Careers;
